const urlsForTesting = [
    "/heizoelpreise/heizoelpreise-lueneburg-21335",
    "/heizoelpreise/heizoelpreise-winsen%20(luhe)-21423",
    "/heizoelpreise/heizoelpreise-regensburg-93047",
];

/**
 * Temporary function to test if a path matches the specified
 * paths which are being used to test the new rating json ld stuff
 *
 * @param {string} path
 * @returns {boolean}
 */
export const isTestRatingUrl = (path: string): boolean => {
    return urlsForTesting.includes(path);
};
